<div class="application-view-main-container">
    <div class="application-view-title">Użytkownik</div>
    <div class="buttons-container">
        <button *ngIf="!this.userDataService.isUserAdmin && !this.userDataService.isUserPanasonicAdmin" type="button" class="btn btn-third-custom btn-third-option" (click)="redirecTo('userDetails')">Informacje o użytkowniku</button>
        <button type="button" class="btn btn-third-custom btn-third-option" (click)="redirecTo('passwordChange')">Zmiana hasła</button>
    </div>
</div>
